(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nfiniti-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const opener=event.target.closest('[data-ns-open]');if(opener){const dialog=document.getElementById(opener.dataset.nsOpen);if(dialog){dialog.showModal();}}const closer=event.target.closest('[data-ns-close]');if(closer){closer.closest('dialog').close();}if(event.target.matches('.ns-dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom){event.target.close();}}});

  } catch(e) { console.error(e); }
})();
})();
